function path(root: string, sublink: string): string {
  return `${root}${sublink}`;
}

export const ROOTS_DASHBOARD = '/dashboard';
export const ROOT_AUTH = '/auth';
export const ROOT_WIZARD = '/wizard';
export const ROOT_CAREER_DISCOVERY = '/career-discovery';

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  admin: {
    pageInsights: path(ROOTS_DASHBOARD, '/advisor/insights'),
    pageStudentOverview: path(ROOTS_DASHBOARD, '/advisor/student-overview'),
    pageStudentAdvising: path(ROOTS_DASHBOARD, '/advisor/student-advising'),
    pageCourseRecommendations: path(ROOTS_DASHBOARD, '/advisor/course-recommendations'),
    pageCareerTrends: path(ROOTS_DASHBOARD, '/advisor/career-trends'),
    pageCareerTrendsOccupation: path(ROOTS_DASHBOARD, '/advisor/career-trends/occupation/:jobTitleId'),
    faq: path(ROOTS_DASHBOARD, '/advisor/faq'),
    contact: path(ROOTS_DASHBOARD, '/advisor/contact'),
  },
};

export const PATH_DASHBOARD_STUDENT = {
  root: ROOTS_DASHBOARD,
  admin: {
    pageHome: path(ROOTS_DASHBOARD, '/learner/home'),
    skills: path(ROOTS_DASHBOARD, '/learner/skills'),
    occupations: path(ROOTS_DASHBOARD, '/learner/occupations'),
    LearningPaths: path(ROOTS_DASHBOARD, '/learner/learning-paths'),
    explorePaths: path(ROOTS_DASHBOARD, '/learner/learning-paths/explore'),
    courses: path(ROOTS_DASHBOARD, '/learner/courses'),
    help: path(ROOTS_DASHBOARD, '/learner/help'),
  },
  profile: {
    information: path(ROOTS_DASHBOARD, '/learner/profile/information'),
    skills: path(ROOTS_DASHBOARD, '/learner/profile/skills'),
    experience: path(ROOTS_DASHBOARD, '/learner/profileExperience'),
  },
};

export const PATH_AUTH = {
  root: ROOT_AUTH,
  login: path(ROOT_AUTH, '/login'),
  register: path(ROOT_AUTH, '/register'),
  forgot: path(ROOT_AUTH, '/forgot'),
  redirect: path(ROOT_AUTH, '/redirect'),
  mfa: path(ROOT_AUTH, '/mfa'),
};

export const PATH_WIZARD = {
  root: ROOT_WIZARD,
  steps: {
    information: path(ROOT_WIZARD, '/information'),
    occupations: path(ROOT_WIZARD, '/occupations'),
    skills: path(ROOT_WIZARD, '/skills'),
    loading: path(ROOT_WIZARD, '/loading'),
    submission: path(ROOT_WIZARD, '/submission'),
  },
};

export const CAREER_DISCOVERY = {
  root: ROOT_CAREER_DISCOVERY,
  steps: {
    ikigai: path(ROOT_CAREER_DISCOVERY, '/ikigai'),
    passion: path(ROOT_CAREER_DISCOVERY, '/passion'),
    mission: path(ROOT_CAREER_DISCOVERY, '/mission'),
    profession: path(ROOT_CAREER_DISCOVERY, '/profession'),
    vocation: path(ROOT_CAREER_DISCOVERY, '/vocation'),
  },
};
